<template>
    <div>
        <v-file-input
            dense=""
            accept="image/png, image/jpeg, image/png, .doc, .docx, .pdf, .xls, .xlsx, .pptx"
            outlined
            rounded
            chips
            prepend-inner-icon="mdi-paperclip"
            prepend-icon
            label="Subir Documento"
            v-model="info"
            @change="data(info, uid)"
            :disabled="isDisabled"
        ></v-file-input>
        Archivos permitidos: Office (doc, docx, xls, xlsx, pptx) Acrobat reader (pdf), Imágenes (jpeg, jpg, png, gif)
    </div>
</template>

<script>

import {mapActions} from "vuex";

export default {
    props: {
        data: Function,
        uid: Number,
        content: [String, File]
    },
    data() {
        return {
            info: this.content
        };
    },
    computed: {
        isDisabled() {
            return this.content ? true : false;
        }
    },
    watch: {
        content() {
            const fileName = this.content.name;
            const extension = fileName.split('.').pop().toLowerCase();
            if(extension != 'jpeg' && extension != 'jpg' && extension != 'png' && extension != 'gif' && 
                extension != 'pdf' && extension != 'doc' && extension != 'docx' && extension != 'xls'
                    && extension != 'xlsx' && extension != 'pptx'){
                    this.toastError({title: "Archivo Invalido", message: "Este archivo no está permitido."});
            }else{
                    this.info = this.content;
            }

        }
    },
    methods: {
            ...mapActions({
                toastError: "toastError"
            })
    }
};
</script>

<style></style>
